<template>
	<div>
		<!-- * une liste des variables utilisées, intéragissable mais surtout pas trop technique -->
		<h3><u>Variables de la requête</u>:</h3>
		<hr />

		<!-- * info intercalage de valeurs colonnes  -->
		<div
			style="cursor: pointer"
			class="d-flex align-items-center w-fit mb-2"
			@click="details_open = !details_open">
			<div
				style="font-size: large"
				class="align-text-bottom w-100 m-1 rounded-lg">
				Info
			</div>
			<i
				style="transition-duration: 0.5s"
				:style="{ transform: details_open ? 'rotate(-180deg)' : '' }"
				class="fas fa-chevron-down"></i>
		</div>

		<!-- * Ancien conteneur de détails -->
		<b-collapse id="collapseInfos" v-model="details_open">
			<div class="flex justify-center items-center mt-2">
				Pour utiliser la valeur d'une colonne dans l'URL, utilisez cette
				syntaxe: {{ "https://example.com/${data.colonne_example}" }}
			</div>
		</b-collapse>
		<!-- * champ de l'URL -->
		<div class="flex justify-left items-center my-3">
			<!-- * texte du verbe (non changeable car une changement de verbe implique souvent de lourds changements au niveau de la requete) -->
			<div class="mr-1 text-lg font-bold">
				{{ value.parameters.verb }}
			</div>
			<!-- * input de l'url, modifiable ici au cas où on voudrait laisser à vide pour avoir colonne uri -->
			<!-- todo j'arrive pas à changer la grandeur de la ligne -->
			<input
				@focusout="() => modifyValues()"
				v-b-tooltip.hover="{
					variant: 'info',
					title: 'Laissez vide pour prendre la colonne uri par défaut',
				}"
				class="w-75 shadow rounded leading-relaxed border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-900 focus:border-b-2"
				type="text"
				v-model="value.parameters.url" />
		</div>
		<div v-for="(property, propertyName) in value.parameters">
			<div v-if="Array.isArray(property) && property.length > 0">
				<h4>
					{{ propertyName }}
				</h4>
				<hr />
				<div v-for="fieldInfo in property">
					<!-- * switch pour alterner entre colonne/valeur -->
					<div class="flex">
						<div
							class="mr-2"
							:class="fieldInfo.col ? 'opacity-25' : ''">
							Valeurs
						</div>
						<b-form-checkbox
							@input="() => modifyValues()"
							switch
							v-model="fieldInfo.col" />
						<div :class="!fieldInfo.col ? 'opacity-25' : ''">
							Colonne
						</div>
					</div>
					{{ fieldInfo.col ? "colonne" : fieldInfo.parameter }}

					<input
						@focusout="() => modifyValues()"
						v-b-tooltip.hover="{
							variant: 'info',
							title: fieldInfo.description,
						}"
						class="w-75 input-color bg-transparent shadow rounded border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-400 focus:border-b-2"
						type="text"
						v-model="fieldInfo.value" />
				</div>
			</div>
		</div>

		<!-- <div>
            <b-button
                class="m-md-2"
                variant="outline-primary"
                @click="() => modifyValues()">
                Modifer
            </b-button>
        </div> -->
	</div>
</template>

<script>
	export default {
		name: "request_perso_overview",
		props: {
			value: {
				type: Object,
			},
		},
		data: function () {
			return {
				details_open: false,
			};
		},
		computed: {
			// inputVal: {
			//     get() {
			//         return this.value;
			//     },
			//     set(val) {
			//         this.$emit('input', val);
			//     }
			// }
		},
		methods: {
			modifyValues: function () {
				console.log("Changed some values: ", this.value);
				this.$emit("changedReq", this.value);
			},
		},
		mounted() {},
	};
</script>
